module.exports = __webpack_public_path__ + "assets/img/checked3-3bd7fe1f.png";